import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARTER_DASHBOARD_CONTACT_DM = createFcmDetails('starter_dashboard_contact_dm', {
	owner: 'Campaign Squad',
	context: 'Starter dashboard email DM notification',
	description:
		'Currently English feature, US only. Determines whether to enable contact DM notification of the starter dashboard',
	template: {
		emailEnabled: false,
		emailSubjectLine: 'Subject line here',
		emailBody: ['Dear DM', 'Please respond', 'Best regards'],
	},
	import: false,
});
